import {postCreateUserTournament} from '../api/postCreateUser';
import { setGetViewTournamentStat } from './setGetViewTournamentStat';

const setPostCreateUser = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCreateUserTournament(params);
            dispatch(setGetViewTournamentStat({id_tournament: params.id_tournament}))
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateUser
}